import { Middleware, isRejected, isFulfilled, Action } from '@reduxjs/toolkit';
import { 
  createNewTranslationRecord,
  approveTranslation,
  declineTranslation,
  proposeTranslationEdit,
  deactivateTranslationAsync,
  fetchTranslations,
} from '../slices/translationsSlice';
import { fetchAITranslation, reactivateTranslationAsync } from '../slices/aiTranslationSlice';
import { toastService } from '../../services/toastService';

const TOAST_CONFIG: Record<string, { success?: string; error?: string }> = {
  // Create translation
  [createNewTranslationRecord.fulfilled.type]: {
    success: 'New translation submitted',
  },
  [createNewTranslationRecord.rejected.type]: {
    error: 'Failed to create new translation',
  },
  
  // Approve translation
  [approveTranslation.fulfilled.type]: {
    success: 'Translation approved',
  },
  [approveTranslation.rejected.type]: {
    error: 'Failed to approve translation',
  },
  
  // Decline translation
  [declineTranslation.fulfilled.type]: {
    success: 'Translation declined',
  },
  [declineTranslation.rejected.type]: {
    error: 'Failed to decline translation',
  },
  
  // Propose translation edit
  [proposeTranslationEdit.fulfilled.type]: {
    success: 'Translation edit proposed successfully',
  },
  [proposeTranslationEdit.rejected.type]: {
    error: 'Failed to propose translation edit',
  },
  
  // Deactivate translation
  [deactivateTranslationAsync.fulfilled.type]: {
    success: 'Translation deactivated',
  },
  [deactivateTranslationAsync.rejected.type]: {
    error: 'Failed to deactivate translation',
  },
  
  // Fetch translations
  [fetchTranslations.rejected.type]: {
    error: 'Failed to fetch translations',
  },
  
  // AI translation
  [fetchAITranslation.rejected.type]: {
    error: 'Translation failed',
  },

  // Reactivate translation
  [reactivateTranslationAsync.fulfilled.type]: {
    success: 'Translation reactivated successfully',
  },
  [reactivateTranslationAsync.rejected.type]: {
    error: 'Failed to reactivate translation',
  },
};

export const toastMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);
  
  const config = TOAST_CONFIG[(action as Action).type];
  if (!config) {
    return result;
  }

  let message: string | undefined;
  let type: 'success' | 'error' | undefined;

  if (isFulfilled(action)) {
    message = config.success;
    type = 'success';
  } else if (isRejected(action)) {
    // Try to get error message from payload, error object, or use default
    message = 
      (action.payload as string) || 
      (action.error?.message as string) || 
      config.error;
    type = 'error';
  }

  if (message && type) {
    // Show toast asynchronously to avoid blocking
    setTimeout(() => {
      toastService.show(message!, type!);
    }, 0);
  }

  return result;
};
